import { TeamTabNavigationProp } from "../TeamTab";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { CompositeNavigationProp } from "@react-navigation/native";

export type TeamHomeStackParamList = {
  TeamHomeMain: {
    teamId: string;
  };
  TeamSchedule: {
    teamId: string;
    focusFrequency?: "DAILY" | "WEEKLY" | "MONTHLY";
  };
};

export type TeamHomeStackNavigationProp<
  T extends keyof TeamHomeStackParamList,
> = CompositeNavigationProp<
  TeamTabNavigationProp<"TeamHome">,
  NativeStackNavigationProp<TeamHomeStackParamList, T>
>;

export const TeamHomeStack =
  createNativeStackNavigator<TeamHomeStackParamList>();
